<app-full-layout>
    <div class="flex-container" fxLayout="row wrap" fxLayoutAlign="start">
        <mat-card class="flex-item trial-card" fxFlex="400px" fxFlex.sm="50%" fxFlex.xs="90%">
            <mat-card-content>
                <mat-card-title i18n>Try KlickData</mat-card-title>
                <app-form-error
                    [header]="'Registration failed'"
                    i18n-header
                    [messages]="(error | async)?.messages"
                ></app-form-error>
                <p i18n>
                    Register for a free demo of KlickData
                </p>
                <form (ngSubmit)="onSubmit()" #loginForm fxLayout="row wrap" fxLayoutAlign="center">
                    <p fxFlex="1 1 100%" i18n>
                        Give us some details so you can log in
                    </p>
                    <mat-form-field fxFlex="1 1 100%">
                        <mat-placeholder>
                            <i class="material-icons app-input-icon">account_box</i>
                            <ng-container i18n>E-mail</ng-container>
                        </mat-placeholder>
                        <input
                            matInput
                            type="email"
                            [(ngModel)]="register.email"
                            name="email"
                            (blur)="register.username = register.email"
                            required
                        />
                        <mat-error i18n="@@tryEmailError">Email is required</mat-error>
                    </mat-form-field>

                    <mat-form-field fxFlex="1 1 100%">
                        <mat-placeholder>
                            <i class="material-icons app-input-icon">lock</i>
                            <ng-container i18n>Choose a password</ng-container>
                        </mat-placeholder>
                        <input
                            matInput
                            type="password"
                            [(ngModel)]="register.password"
                            name="password"
                            minlength="6"
                            required
                        />
                        <mat-error i18n="@@tryPasswordError">Password must be at least 8 characters long</mat-error>
                    </mat-form-field>

                    <p fxFlex="1 1 100%" i18n>
                        Please tell us more about you
                    </p>

                    <mat-form-field fxFlex="1 1 100%">
                        <mat-placeholder>
                            <ng-container i18n>Company / Organization / School</ng-container>
                        </mat-placeholder>
                        <input matInput [(ngModel)]="register.organisation" name="organisation" />
                    </mat-form-field>

                    <mat-form-field fxFlex="1 1 100%">
                        <mat-placeholder>
                            <ng-container i18n>First name</ng-container>
                        </mat-placeholder>
                        <input matInput [(ngModel)]="register.fname" name="firstname" />
                    </mat-form-field>

                    <mat-form-field fxFlex="1 1 100%">
                        <mat-placeholder>
                            <ng-container i18n>Last name</ng-container>
                        </mat-placeholder>
                        <input matInput [(ngModel)]="register.lname" name="lastname" />
                    </mat-form-field>

                    <div class="signup-button">
                        <button mat-raised-button color="primary" type="submit" i18n>Sign up</button>
                    </div>
                </form>
                <p class="text-center">
                    <button mat-button (click)="goBack()" i18n>Cancel</button>
                </p>
            </mat-card-content>
        </mat-card>
    </div>
</app-full-layout>
